import ApiServer from "../ApiServer.ts";
import {SyncCache} from "../lib/SyncCache.ts";
import { birthDateBean } from "../server/decoders_connected.ts";
import { IAddress, IContact, IDevice } from "../server/fizapilib.auto.ts";
import Icons, { SvgFile } from "../svg/Icons.ts";

// Augmentation of the generated beans with the properties and methods added dynamically below
declare module "../server/fizapilib.auto.ts" {
  interface IContact {
    birthDateBean?: typeof birthDateBean;
    /** first and last name joined */
    displayName?: string;
    /** something more than the name to display in the contact card */
    hasDetail?: boolean | number;
  }
  interface IDevice {
    /** i18n key of the device type */
    label?: string;
    placeholder?: string;
    icon?: SvgFile;
  }
  interface IAddress {
    /** i18n key of the place type */
    label?: string;
    placeholder?: string;
    icon?: SvgFile;
  }
}

//ctcsync returns IContact, ContactBean is another bean with the same fields
export const ContactCache = new SyncCache<IContact>(
  ApiServer.ctcsync,
  function(a,b){return a.displayName.localeCompare(b.displayName)
})

Object.assign(IContact.prototype,{
  onDecode(this: IContact): void {
    this.birthDateBean = birthDateBean
    this.displayName = ((this.firstName||"")+" "+(this.lastName||"")).trim();
    this.hasDetail = this.devices.length||this.addresses.length ||this.birthDate!==undefined
  }
 });

 Object.assign(IDevice.prototype,{
  onDecode(this: IDevice): void {
    this.label = {
      MOBILE:'labels.mobile',
      EMAIL:'labels.email'
      }[this.deviceType]||'labels.phone'
    this.placeholder = {
      EMAIL:'johndoe@email.com'
      }[this.deviceType]||'(902) 930-3589'

    this.icon = {
      MOBILE:Icons.contact.ic_contact_mobile_phone,
      EMAIL:Icons.ic_email
      }[this.deviceType]||Icons.contact.ic_contact_phone

  }
 });

 Object.assign(IAddress.prototype,{
  onDecode(this: IAddress): void {
    this.label = {
      WORK:'addressType.WORK'
      }[this.placeType]||'addressType.HOME'
    this.icon = {
      WORK:  Icons.contact.ic_contact_work_address
      }[this.placeType]||Icons.ic_location

    this.placeholder = 'modalplace.placeholder_address'

  }
 });
